import { getZrmListingInfo, getZrmUserInfo } from '@zg-rentals/clickstream';

import { _nextTrackEvent } from '../index';

import type { ZrmClickstreamListing, ZrmClickstreamUser } from '@zg-rentals/clickstream';

const EVENT_IDS = {
  CLICK_NEXT_STEPS: '4805',
  CLICK_UPGRADE_TO_PREMIUM_FROM_REC_ACTIONS: '8296',
} as const;

export const CLICK_NEXT_STEPS_RECOMMENDATIONS_EVENT_ID = EVENT_IDS.CLICK_NEXT_STEPS;

// https://dataportal.zillowgroup.net/event-registry/4805
export const emitClickNextStepsRecommendationsEvent = ({
  currentProperty,
  user,
  triggerObject = 'recommended_action',
  triggerSource = 'adjust_screening_preferences',
}: {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
  triggerObject: string;
  triggerSource: string;
}) =>
  _nextTrackEvent.listingUser({
    envelope: {
      event_template_id: '177',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.CLICK_NEXT_STEPS,
      event_type_version_id: '6',
    },
    clickstream_trigger: {
      trigger_location_nm: 'zrm_property_overview',
      trigger_type_nm: 'interaction',
      trigger_object_nm: triggerObject,
      trigger_source_nm: triggerSource,
    },
    semantic: {
      semantic_event_nm: 'single_property_dashboard',
      topic_tag_txt: ['zrm_leases', 'zrm_payments', 'zrm_properties', 'property_condition', 'zrm_rental_protection'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/8296
export const emitClickUpgradeToPremiumFromRecActionsEvent = ({
  currentProperty,
  user,
}: {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
}) =>
  _nextTrackEvent.listingUser({
    envelope: {
      event_type_id: EVENT_IDS.CLICK_UPGRADE_TO_PREMIUM_FROM_REC_ACTIONS,
      event_type_version_id: '1',
      event_template_id: '168',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'zrm_property_overview',
      trigger_source_nm: 'upgrade_to_premium',
      trigger_object_nm: 'recommended_actions',
    },
    semantic: {
      semantic_event_nm: 'zrm_premium_begin_checkout',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });
